import React, { useContext } from "react";
import axios from "axios";
import SideMenu from "../components/SideMenu";
import { toast } from "react-toastify";
import { directoryContext } from "../context/Context";

const EditProfile = ({}) => {
  const [loading, setLoading] = React.useState(false);
  const {
    userDispatch,
    userState: { user },
  } = useContext(directoryContext);
  const [inputData, setInputData] = React.useState({
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    website: "",
    company: "",
    desc: "",
    email: "",
  });
  React.useEffect(() => {
    if (user) {
      setInputData({
        firstName: user.name && (user?.name.split(" ")[0] || ""),
        lastName: user.name && (user?.name.split(" ")[2] || ""),
        phone: user?.phone,
        address: user?.address,
        website: user?.website,
        company: user?.company,
        desc: user?.desc,
        email: user?.email,
      });
    }
  }, []);

  const [image, setImage] = React.useState(user?.profilePic);

  const handleChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const {
        firstName,
        lastName,
        phone,
        address,
        website,
        company,
        desc,
        email,
      } = inputData;
      const res = await axios.patch(
        "https://www.api.webdirectories.info/api/auth/update/" + user._id,
        {
          name: `${firstName} ${lastName}`,
          phone,
          address,
          website,
          company,
          desc,
          profilePic: image,
        }
      );
      if (res.status === 200) {
        toast.success("Profile Updated Successfully");
        setInputData({
          firstName: "",
          lastName: "",
          phone: "",
          address: "",
          website: "",
          company: "",
          desc: "",
          email: "",
        });
        userDispatch({ type: "UPDATE_USER", payload: res.data.auth });
        // window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleImage = (e) => {
    const image = e.target.files[0];
    //convert image to base64
    const reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = () => {
      setImage(reader.result);
    };
  };

  return (
    <div>
      <div className="container">
        <div className="row flex-nowrap">
          <SideMenu profilePic={user?.profilePic} />
          <div className="col py-3">
            <h2>Edit Profile</h2>
            <form onSubmit={handleSubmit}>
              <div className="row my-3">
                <div className="col-lg-6">
                  <label className="form-label">First Name</label>
                  <input
                    className="form-control"
                    type="text"
                    name="firstName"
                    value={inputData.firstName}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-lg-6">
                  <label className="form-label">Last Name</label>
                  <input
                    className="form-control"
                    type="text"
                    name="lastName"
                    value={inputData.lastName}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row my-3">
                <div className="col-lg-6">
                  <label className="form-label">Display Name</label>
                  <input
                    className="form-control"
                    type="text"
                    value={`${inputData.firstName} ${inputData.lastName}`}
                    readOnly
                  />
                </div>

                <div className="col-lg-6">
                  <label className="form-label">Registered Email</label>
                  <input
                    className="form-control"
                    type="text"
                    name="email"
                    value={inputData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="row my-3">
                <div className="col-lg-6">
                  <label className="form-label">Contact Email</label>
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    value={inputData.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-lg-6">
                  <label className="form-label">Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone"
                    value={inputData.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row my-3">
                <div className="col-lg-6">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={inputData.address}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-lg-6">
                  <label for="exampleInputEmail1" className="form-label">
                    Website
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="website"
                    value={inputData.website}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row my-3">
                <div className="col-lg-6">
                  <label className="form-label">Company</label>
                  <input
                    type="text"
                    className="form-control"
                    name="company"
                    value={inputData.company}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row my-3">
                <div className="col-lg-12">
                  <label className="form-label">Description</label>
                  <textarea
                    type="text"
                    row="8"
                    className="form-control"
                    name="desc"
                    value={inputData.desc}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row my-3">
                <div className="col-lg-8">
                  <label className="form-label">Change Avatar</label>
                  <input
                    type="file"
                    row="8"
                    className="form-control"
                    onChange={handleImage}
                  />
                </div>

                <div className="col-lg-4">
                  {image && (
                    <img
                      src={image}
                      alt="avatar"
                      height={200}
                      width={200}
                      style={{ objectFit: "contain", borderRadius: "50%" }}
                    />
                  )}
                </div>
              </div>

              <button type="submit" className="btn bbtn btn-primary">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="col-lg-4"></div>
      <div className="col-lg-8"></div>
    </div>
  );
};

export default EditProfile;
